import React from "react";
import { NavLink } from "react-router-dom";
import Shared03Divider from "../../../guestsharedcomponents/Shared03Divider/Shared03Divider";

/* const FOOTER_NAV = [
  { _id: "home", heading: "Home", link: "/" },
  { _id: "courses", heading: "Courses", link: "/courses" },
  { _id: "about", heading: "About Us", link: "/about-us" },
  { _id: "events", heading: "Events", link: "/events" },
  { _id: "pricing", heading: "Pricing", link: "/pricing" },
];

const FOOTER_INFO = [
  { _id: "contact", heading: "Contact Us", link: "/contact-us" },
  { _id: "privacy_policy", heading: "Privacy Policy", link: "privacy-policy" },
  {
    _id: "terms_of_service",
    heading: "Terms of Service",
    link: "/terms-of-service",
  },
];
 */

const FOOTER_NAV = [
  { _id: "home", heading: "Home", link: "/" },
  { _id: "courses", heading: "Courses", link: "/" },
  { _id: "about", heading: "About Us", link: "/" },
  { _id: "events", heading: "Events", link: "/" },
  { _id: "pricing", heading: "Pricing", link: "/" },
];

const FOOTER_INFO = [
  { _id: "contact", heading: "Contact Us", link: "/" },
  { _id: "privacy_policy", heading: "Privacy Policy", link: "/" },
  {
    _id: "terms_of_service",
    heading: "Terms of Service",
    link: "/",
  },
];

//https://members.ltmastery.com/

const FooterLinks = () => {
  return (
    <div className="footer-links">
      <nav className="nav" aria-label="Navegación principal">
        <h3 className="t-h-4">
          Quick Links
          <Shared03Divider
            options={{
              obj_divider: {
                divider_mobile_styles: {
                  width: "50%",
                  background:
                    "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                  margin: "0.5rem auto 0 auto",
                },
                divider_desktop_styles: {
                  width: "60%",
                  background:
                    "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
                  margin: "0.5rem 0",
                },
              },
              style_render: 992,
            }}
          />
        </h3>
        <ul className="t-list-none">
          {FOOTER_NAV.map((item) => (
            <li key={item._id}>
              <NavLink
                to={item.link}
                className={({ isActive }) =>
                  isActive ? "nav-link is-active" : "nav-link"
                }
              >
                {item.heading}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <nav className="nav" aria-label="Navegación principal">
        <h3 className="t-h-4">
          Information
          <Shared03Divider
            options={{
              obj_divider: {
                divider_mobile_styles: {
                  width: "50%",
                  background:
                    "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                  margin: "0.5rem auto 0 auto",
                },
                divider_desktop_styles: {
                  width: "60%",
                  background:
                    "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
                  margin: "0.5rem 0",
                },
              },
              style_render: 992,
            }}
          />
        </h3>
        <ul className="t-list-none">
          {FOOTER_INFO.map((item) => (
            <li key={item._id}>
              <NavLink
                to={item.link}
                className={({ isActive }) =>
                  isActive ? "nav-link is-active" : "nav-link"
                }
              >
                {item.heading}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default FooterLinks;
